import {
    Component
} from "../../../../../sedestral/framework/interface/component/Component";
import * as s from "./website-content.scss";
import {NetworkVendor} from "../../../../../network/NetworkVendor";
import {CustomerPopup} from "../../../../panel/components/components/customer/popup/types/CustomerPopup";
import {WebsiteBlackPlatformComponent} from "../black/platform/WebsiteBlackPlatformComponent";
import {WebsiteBlackFlowComponent} from "../black/flow/WebsiteBlackFlowComponent";
import {WebsiteBlackTextComponent} from "../black/text/WebsiteBlackTextComponent";
import {WebsiteBlackStepsComponent} from "../black/steps/WebsiteBlackStepsComponent";
import {WebsiteBlackPresentationComponent} from "../black/presentation/WebsiteBlackPresentationComponent";
import * as r from "../black/presentation/website-black-presentation.scss";
import {WebsiteBlackWordsComponent} from "../black/words/WebsiteBlackWordsComponent";
import {WebsiteBlackCasesComponent} from "../black/cases/WebsiteBlackCasesComponent";
import {Resources} from "../../../../../resources/Resources";
import {WebsiteIssuesComponent} from "../white/issues/WebsiteIssuesComponent";
import {WebsiteBlackPlatformHomeComponent} from "../black/platform/models/WebsiteBlackPlatformHomeComponent";
import {WebsiteBlackFlowGridComponent} from "../black/flow/grid/WebsiteBlackFlowComponent";
import {WebsiteBlackSearchComponent} from "../black/search/WebsiteBlackSearchComponent";
import {WebsiteBlackBlockComponent} from "../black/block/WebsiteBlackBlockComponent";
import {Network} from "../../../../../network/Network";

export class WebsiteContentPrestashopComponent extends Component {
    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteContent}">
                <div class="${s.content}">
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackPresentationComponent({
                            startText: Resources.t("words.beginFree"),
                            center: true,
                            title: Resources.t("words.shopifySeoVisibilityTitle"),
                            titleSize: "mid",
                            description: Resources.t("words.prestaSedestralDescription"),
                            partnerIcon: "prestashop",
                            blackButton: Resources.t("words.shopifyTalkToExpert"),
                            blackButtonLink: Network.router.pages.getUrlWithPath('schedule'),
                            buttonsSameWidth: true,
                            limited: Resources.t("words.shopifyLimitedOffer")
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackStepsComponent({
                            title: Resources.t("words.shopifyFeaturesTitle"),
                            icon: "prestashop",
                            contents: [
                                {
                                    name: Resources.t("words.shopifyOptimization"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-bg.mp4"),
                                    duration: 30000
                                },
                                {
                                    name: Resources.t("words.shopifyAudit"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-bh.mp4"),
                                    duration: 24000
                                },
                                {
                                    name: Resources.t("words.shopifyResearch"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-bi.mp4"),
                                    duration: 26000
                                },
                                {
                                    name: Resources.t("words.shopifyAnalysis"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-bj.mp4"),
                                    duration: 23000
                                },
                                {
                                    name: Resources.t("words.shopifyCreation"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-bk.mp4"),
                                    duration: 21000
                                }
                            ]
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackSearchComponent({
                            title: Resources.t("words.prestaIgnoreSeoWarning"),
                            keyword: "acheter basket running femme",
                            stats: {
                                description: Resources.t("words.shopifySeoKeywordStatsDescription"),
                                color: "green",
                                entries: [
                                    {
                                        title: Resources.t("words.shopifyPosition1"),
                                        color: "green",
                                        width: "90%",
                                        value: "1 990"
                                    },
                                    {
                                        title: Resources.t("words.shopifyPosition9"),
                                        color: "white",
                                        width: "5%",
                                        value: "95"
                                    },
                                    {
                                        title: Resources.t("words.shopifyPosition12"),
                                        color: "white",
                                        width: "2%",
                                        value: "40"
                                    }
                                ]
                            },
                            cases: {
                                title: Resources.t("words.shopifySeoImpactTitle"),
                                cases: [
                                    {
                                        name: Resources.t("words.shopifySeoImpactPage12To4"),
                                        value: "x10"
                                    },
                                    {
                                        name: Resources.t("words.shopifySeoImpactPage2To1"),
                                        value: "0,7% -> 7%"
                                    }
                                ]
                            }
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackTextComponent({
                            text: Resources.t("words.shopifySeoMetaphor"),
                            size: "sizeMid",
                            shadow: "colorGreen"
                        }))}
                    </div>
                </div>
                <div class="${s.white}">
                    <div class="${s.content}">
                        <div class="${s.container}">
                            ${this.draw(new WebsiteBlackFlowComponent({
                                title: Resources.t("words.createAndOptimize"),
                                bigTitle: Resources.t("words.shopifyAllInOneTitle"),
                                image: NetworkVendor.image("blog-c.webp"),
                                texts: {
                                    canCollapse: false,
                                    entries: [
                                        {
                                            title: Resources.t("words.auditYourSite"),
                                            description: Resources.t("words.auditDescription"),
                                            icon: "fire",
                                            iconColor: "colorPurple"
                                        },
                                        {
                                            title: Resources.t("words.autoOptimizeExistingContent"),
                                            description: Resources.t("words.autoOptimizeDescription"),
                                            icon: "aiStars",
                                            iconColor: "colorPurple"
                                        },
                                        {
                                            title: Resources.t("words.createEngagingSeoContent"),
                                            description: Resources.t("words.createEngagingDescription"),
                                            icon: "aiWrite",
                                            iconColor: "colorPurple"
                                        }, {
                                            title: Resources.t("words.analyzePerformance"),
                                            description: Resources.t("words.performanceDescription"),
                                            icon: "chart",
                                            iconColor: "colorPurple"
                                        }
                                    ]
                                }
                            }))}
                        </div>
                        <div class="${s.container}">
                            ${this.draw(new WebsiteBlackFlowGridComponent({
                                title: Resources.t("words.prestaAutoPublishModule"),
                                lines: [{
                                    entries: [
                                        {
                                            title: Resources.t("words.shopifyProductPages"),
                                            description: Resources.t("words.shopifyProductPagesDescription"),
                                            illustration: "pageProduct"
                                        },
                                        {
                                            title: Resources.t("words.shopifyBlogArticles"),
                                            description: Resources.t("words.shopifyBlogArticlesDescription"),
                                            illustration: "pageBlog"
                                        },
                                        {
                                            title: Resources.t("words.shopifyKeyPages"),
                                            description: Resources.t("words.shopifyKeyPagesDescription"),
                                            illustration: "pageSimple"
                                        }
                                    ]
                                }]
                            }))}
                        </div>
                    </div>
                </div>
                <div class="${s.content}">
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackBlockComponent({
                            text: Resources.t("words.prestaFreeBlogModule"),
                            icon: "prestashop",
                            background: "blueTurk",
                            buttons: [
                                {
                                    name: Resources.t("words.downloadBlogModule"),
                                    color: "turk",
                                    link: Network.router.pages.getUrlWithPath('prestashop')
                                },
                            ]
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackPlatformHomeComponent(true))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteIssuesComponent({
                            theme: "black",
                            questions: [
                                {
                                    question: Resources.t("words.shopifyFaqSalesHelpQuestion"),
                                    response: Resources.t("words.shopifyFaqSalesHelpResponse")
                                },
                                {
                                    question: Resources.t("words.shopifyFaqVsOthersQuestion"),
                                    response: Resources.t("words.shopifyFaqVsOthersResponse")
                                },
                                {
                                    question: Resources.t("words.prestaCompatibilityQuestion"),
                                    response: Resources.t("words.prestaCompatibilityAnswer")
                                },
                                {
                                    question: Resources.t("words.shopifyFaqFreeTrialQuestion"),
                                    response: Resources.t("words.shopifyFaqFreeTrialResponse")
                                },
                                {
                                    question: Resources.t("words.shopifyFaqNoExpertiseQuestion"),
                                    response: Resources.t("words.shopifyFaqNoExpertiseResponse")
                                }
                            ]
                        }))}
                    </div>
                </div>
            </div>
        `;
    }

    commit() {
        CustomerPopup.blog();
        super.commit();
    }
}



